<template>
  <div class="accFeed__wrapper matchmaking__wrapper subscriptions-page wide">
    <div class="accFeed__content matchmaking__content">
      <div class="market-project">
        <div class="offers">
          <div class="offers-status">
            <h3>You have <strong>
              {{ filteredSubscriptions.length }}</strong> projects subscriptions:</h3>
          </div>
        </div>

        <SuccessMessage v-if="messageText" :text="messageText" />

        <div class="subscribe">
          <div v-if="isLoading" class="d-flex justify-content-center p-2">
            <div class="loader"></div>
          </div>

          <div v-else-if="!filteredSubscriptions.length" class="no-content">
            <p>You have <strong>no subscriptions</strong> yet.</p>
          </div>

          <div v-else class="accordion" id="accordionSubscribes">
            <div
              v-for="subscription in filteredSubscriptions"
              :key="subscription.id"
              class="subscribe__item"
            >
              <div class="subscribe__header" :id="subscription.headerId">
                <label class="subscribe__label mb-0">
                  <input
                    v-model="editForms[subscription.id].enabled"
                    type="checkbox"
                    class="subscribe__checkbox"
                  >
                  <span class="subscribe__custom-check"></span>
                  Marketplace:
                  <strong>
                    {{ subscription.marketplace.name }}, Country: {{ subscription.country.name || 'Any country' }}
                  </strong>
                </label>
                <button
                  class="btn-accordion"
                  :class="{ collapsed: expandedId !== subscription.id }"
                  type="button"
                  :aria-expanded="expandedId === subscription.id ? 'true' : 'false'"
                  :aria-controls="subscription.collapseId"
                  @click="toggleExpand(subscription.id)"
                >
                </button>
              </div>

              <div
                :id="subscription.collapseId"
                class="collapse"
                :class="{ show: expandedId === subscription.id }"
                :aria-labelledby="subscription.headerId"
              >
                <div class="subscribe__body">
                  <div class="subscribe__buttons">
                    <div class="subscribe-form-row">
                      <label>Marketplace</label>
                      <select
                        v-model="editForms[subscription.id].marketplace_id"
                        class="form-control"
                        @change="onEditMarketplaceChange(subscription.id)"
                      >
                        <option v-for="mp in marketplaces" :key="mp.id" :value="String(mp.id)">
                          {{ mp.name }}
                        </option>
                      </select>
                    </div>

                    <div class="subscribe-form-row">
                      <label>Country</label>
                      <select v-model="editForms[subscription.id].country_id" class="form-control">
                        <option value="">Any country</option>
                        <option
                          v-for="country in getEditCountryOptions(subscription.id)"
                          :key="country.id"
                          :value="String(country.id)"
                        >
                          {{ country.name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="subscribe__buttons">
                    <a class="btn-action" href="#" @click.prevent="saveSubscription(subscription.id)">
                      Save subscription settings
                    </a>
                    <a
                      class="btn-action"
                      href="#"
                      @click.prevent="toggleSubscriptionContents(subscription)"
                    >
                      Display contents
                    </a>
                  </div>

                  <div v-if="contentsVisibleId === subscription.id" class="subscription-contents">
                    <div v-if="contentsLoadingId === subscription.id" class="d-flex justify-content-center p-2">
                      <div class="loader"></div>
                    </div>

                    <div v-else-if="!getSubscriptionContents(subscription.id).length" class="no-content">
                      <p><strong>No projects</strong> match this subscription.</p>
                    </div>

                    <div v-else class="accordion offers__box subscription-contents__cards">
                      <div
                        v-for="project in getSubscriptionContents(subscription.id)"
                        :key="project.id"
                        class="card accordion-multi project-card"
                      >
                        <div class="card-header">
                          <button
                            type="button"
                            class="btn-accordion no-arrow"
                            :class="contentsAccordionClass(project)"
                            aria-expanded="false"
                            @click="openProject(project)"
                          >
                            <div class="market-project__content">
                              <h3 class="market-project__title">
                                <a href="#" @click.stop.prevent="openProject(project)">
                                  {{ project.name }}
                                </a>
                              </h3>

                              <ul class="specs-grid">
                                <li v-if="project.company_country && project.company_country.name">
                                  Country: <strong>{{ project.company_country.name }}</strong>
                                </li>

                                <li
                                  v-for="spec in subscriptionProjectSpecs(project)"
                                  :key="spec.key"
                                >
                                  {{ spec.label }}:
                                  <strong>{{ spec.value }}</strong>
                                </li>
                              </ul>
                            </div>

                            <div class="market-project__actions">
                              <div class="market-project__info offer">
                                <span class="deadline-info">
                                  <i class="icon-calendar"></i>Offer deadline:
                                  <strong>{{ formatDeadline(project.deadline_at) }}</strong>
                                </span>

                                <p v-if="Number(project.offers_count || 0) === 1">
                                  <strong>{{ project.offers_count }}</strong> offer from Seller
                                </p>

                                <p v-else-if="Number(project.offers_count || 0) > 1">
                                  <strong>{{ project.offers_count }}</strong> offers from Sellers
                                </p>

                                <p v-else class="no-offer-text">
                                  No offers yet
                                </p>
                              </div>

                              <div v-if="contentsStatusLabel(project)" class="status-multi">
                                <h6>Status:</h6>
                                <span class="status" :class="contentsStatusClass(project)">
                                  {{ contentsStatusLabel(project) }}
                                </span>
                              </div>

                              <div class="market-project__buttons buttons-group">
                                <a
                                  v-if="!project.saved"
                                  href="#"
                                  class="btn-action"
                                  @click.stop.prevent="toggleSavedInContents(subscription.id, project, true)"
                                >
                                  Save
                                </a>

                                <a
                                  v-else
                                  href="#"
                                  class="btn-action btn-reject"
                                  @click.stop.prevent="toggleSavedInContents(subscription.id, project, false)"
                                >
                                  Unsave
                                </a>

                                <a
                                  href="#"
                                  class="btn-action"
                                  @click.stop.prevent="openProject(project)"
                                >
                                  See Details
                                </a>

                                <a
                                  href="#"
                                  class="btn-action"
                                  @click.stop.prevent="openProject(project)"
                                >
                                  Send message
                                </a>

                                <a
                                  v-if="Number(project.offers_allow) === 1 && Number(project.status) !== 2"
                                  href="#"
                                  class="btn-action"
                                  @click.stop.prevent="openProject(project)"
                                >
                                  Make an Offer
                                </a>
                              </div>
                            </div>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MatchmakingService from '@/services/MatchmakingService';
import SuccessMessage from '@/components/matchmaking/SuccessMessage.vue';

export default {
  name: 'SellerSubscriptions',
  components: {
    SuccessMessage,
  },
  data() {
    return {
      searchQuery: '',
      selectedMarketplaceId: null,
      selectedCountryId: null,
      expandedId: null,
      isLoading: false,
      messageText: '',
      messageTimer: null,
      subscriptions: [],
      marketplaces: [],
      editForms: {},
      contentsBySubscriptionId: {},
      contentsVisibleId: null,
      contentsLoadingId: null,
    };
  },
  computed: {
    filteredSubscriptions() {
      const q = String(this.searchQuery || '').trim().toLowerCase();
      return this.subscriptions.filter((s) => {
        const byMarketplace = !this.selectedMarketplaceId
          || String(s.marketplace?.id || '') === String(this.selectedMarketplaceId);
        const byCountry = !this.selectedCountryId
          || String(s.country?.id || '') === String(this.selectedCountryId);
        const haystack = `${s.marketplace?.name || ''} ${s.country?.name || ''}`.toLowerCase();
        const bySearch = !q || haystack.includes(q);
        return byMarketplace && byCountry && bySearch;
      });
    },
    countryFilterOptions() {
      return this.getMarketplaceCountries(this.selectedMarketplaceId);
    },
  },
  async created() {
    await this.fetchMarketplaces();
    await this.fetchSubscriptions();
  },
  beforeDestroy() {
    if (this.messageTimer) clearTimeout(this.messageTimer);
  },
  methods: {
    showMessage(text) {
      this.messageText = text;
      if (this.messageTimer) clearTimeout(this.messageTimer);
      this.messageTimer = setTimeout(() => {
        this.messageText = '';
        this.messageTimer = null;
      }, 4000);
    },
    onSelectMarketplace(marketplaceId) {
      this.selectedMarketplaceId = marketplaceId;
      this.selectedCountryId = null;
    },
    normalizeListPayload(payload) {
      if (Array.isArray(payload)) return payload;
      if (payload && Array.isArray(payload.data)) return payload.data;
      if (payload && Array.isArray(payload.items)) return payload.items;
      return [];
    },
    ensureApiOk(responseData) {
      if (
        responseData
        && typeof responseData === 'object'
        && Number(responseData.status || 0) >= 400
      ) {
        throw new Error(responseData.message || 'Request failed');
      }
    },
    normalizeProjectsPayload(payload) {
      if (Array.isArray(payload)) return payload;
      if (payload && Array.isArray(payload.data)) return payload.data;
      if (payload && Array.isArray(payload.items)) return payload.items;
      return [];
    },
    async fetchMarketplaces() {
      try {
        const { data } = await MatchmakingService.marketplaces();
        this.marketplaces = Array.isArray(data) ? data : [];
      } catch (e) {
        this.marketplaces = [];
      }
    },
    toSubscriptionVM(item) {
      const id = item?.id;
      return {
        id,
        marketplace: item?.marketplace || {},
        country: item?.country || {},
        headerId: `s-head-${id}`,
        collapseId: `s-collapse-${id}`,
      };
    },
    initEditForms() {
      const forms = {};
      (this.subscriptions || []).forEach((subscription) => {
        forms[subscription.id] = {
          marketplace_id: String(subscription.marketplace?.id || ''),
          country_id: String(subscription.country?.id || ''),
          enabled: true,
        };
      });
      this.editForms = forms;
    },
    async fetchSubscriptions() {
      this.isLoading = true;
      try {
        const { data } = await MatchmakingService.marketplaceProjectSubscriptions();
        const list = this.normalizeListPayload(data);
        this.subscriptions = list.map(this.toSubscriptionVM);
        this.initEditForms();
      } catch (e) {
        this.subscriptions = [];
        this.editForms = {};
      } finally {
        this.isLoading = false;
      }
    },
    getMarketplaceCountries(marketplaceId) {
      if (!marketplaceId) return [];
      const mp = (this.marketplaces || [])
        .find((marketplace) => String(marketplace?.id) === String(marketplaceId));
      // eslint-disable-next-line no-nested-ternary
      const raw = Array.isArray(mp?.filters?.countries)
        ? mp.filters.countries
        : (Array.isArray(mp?.countries) ? mp.countries : []);

      return raw
        .filter((country) => country && country.id !== undefined && country.id !== null)
        .map((country) => ({
          id: String(country.id),
          name: country.name || country.nicename || country.iso || String(country.id),
          iso: country.iso || '',
        }));
    },
    toggleExpand(id) {
      this.expandedId = this.expandedId === id ? null : id;
    },
    onEditMarketplaceChange(subscriptionId) {
      if (!this.editForms[subscriptionId]) return;
      this.editForms[subscriptionId].country_id = '';
    },
    getEditCountryOptions(subscriptionId) {
      const marketplaceId = this.editForms[subscriptionId]?.marketplace_id;
      return this.getMarketplaceCountries(marketplaceId);
    },
    getSubscriptionContents(subscriptionId) {
      const key = String(subscriptionId);
      return this.contentsBySubscriptionId[key] || [];
    },
    async loadSubscriptionContents(subscription) {
      const subscriptionId = String(subscription.id);
      const marketplaceId = Number(subscription?.marketplace?.id || 0);
      if (!marketplaceId) {
        this.contentsBySubscriptionId = {
          ...this.contentsBySubscriptionId,
          [subscriptionId]: [],
        };
        return;
      }

      this.contentsLoadingId = subscription.id;
      try {
        const res = await MatchmakingService.marketplaceProjects(marketplaceId, false);
        const list = this.normalizeProjectsPayload(res?.data);
        const countryId = String(subscription?.country?.id || '').trim();
        const filtered = !countryId
          ? list
          : list.filter((project) => String(project?.company_country?.id || '') === countryId);

        this.contentsBySubscriptionId = {
          ...this.contentsBySubscriptionId,
          [subscriptionId]: filtered,
        };
      } catch (e) {
        this.contentsBySubscriptionId = {
          ...this.contentsBySubscriptionId,
          [subscriptionId]: [],
        };
      } finally {
        this.contentsLoadingId = null;
      }
    },
    async toggleSubscriptionContents(subscription) {
      if (!subscription?.id) return;
      if (this.contentsVisibleId === subscription.id) {
        this.contentsVisibleId = null;
        return;
      }

      this.contentsVisibleId = subscription.id;
      const cached = this.getSubscriptionContents(subscription.id);
      if (Array.isArray(cached) && cached.length) return;
      await this.loadSubscriptionContents(subscription);
    },
    buildProjectRouteId(project) {
      const countryIso = String(project?.company_country?.iso || 'xx').toLowerCase();
      return `${countryIso}-${project.id}`;
    },
    openProject(project) {
      const projectId = this.buildProjectRouteId(project);
      this.$router.push({
        name: 'projectDetails',
        params: { type: 'seller', id: projectId },
      }).catch(() => {});
    },
    formatDeadline(deadline) {
      if (!deadline || deadline === '∞') return 'not specified';
      return deadline;
    },
    contentsAccordionClass(project) {
      const status = Number(project?.status || 0);
      if (status === 2) return 'approved';
      if (status === 4) return 'expired';
      if (project?.saved) return 'saved';
      if (Number(project?.offers_count || 0) > 0) return 'offered';
      return 'published';
    },
    contentsStatusLabel(project) {
      const status = Number(project?.status || 0);
      if (status === 2) return 'Approved';
      if (status === 4) return 'Expired';
      if (project?.saved) return 'Saved';
      return '';
    },
    contentsStatusClass(project) {
      const status = Number(project?.status || 0);
      if (status === 2) return 'approved';
      if (status === 4) return 'expired';
      if (project?.saved) return 'saved';
      return '';
    },
    subscriptionProjectDataList(project) {
      const d = project?.data;
      if (Array.isArray(d)) return d.filter(Boolean);
      if (d && typeof d === 'object') return Object.values(d).filter(Boolean);
      return [];
    },
    resolveDropboxLabel(values, key) {
      if (!values) return '';
      if (Array.isArray(values)) {
        const found = values.find((v) => v && String(v.id) === String(key));
        if (!found) return '';
        return found.name || found.value || String(key);
      }
      return values[key] || values[String(key)] || '';
    },
    formatCategoryValue(category) {
      if (!category) return '';
      if (category.type === 'dropbox') {
        const values = category.values || {};
        if (category.multiple) {
          const raw = category.initValue;
          // eslint-disable-next-line no-nested-ternary
          const ids = Array.isArray(raw) ? raw : (raw ? [raw] : []);
          return ids.map((id) => this.resolveDropboxLabel(values, id)).filter(Boolean).join(', ');
        }
        if (category.initValue === null || category.initValue === undefined || category.initValue === '') {
          return '';
        }
        return this.resolveDropboxLabel(values, category.initValue);
      }
      if (category.initValue === null || category.initValue === undefined || category.initValue === '') {
        return '';
      }
      return String(category.initValue);
    },
    subscriptionProjectSpecs(project) {
      const list = this.subscriptionProjectDataList(project);
      return list
        .map((item, idx) => {
          if (!item || !item.name) return null;
          const value = this.formatCategoryValue(item);
          if (!value) return null;
          return {
            key: `${project?.id || 'project'}-${idx}`,
            label: item.name,
            value,
          };
        })
        .filter(Boolean);
    },
    async toggleSavedInContents(subscriptionId, project, shouldSave) {
      if (!project?.id) return;
      try {
        if (shouldSave) {
          await MatchmakingService.sellerSaveProject({ project_id: project.id });
        } else {
          await MatchmakingService.sellerUnsaveProject({ project_id: project.id });
        }

        const key = String(subscriptionId);
        const current = this.contentsBySubscriptionId[key] || [];
        const next = current.map((item) => (
          String(item?.id) === String(project.id)
            ? { ...item, saved: shouldSave }
            : item
        ));
        this.contentsBySubscriptionId = {
          ...this.contentsBySubscriptionId,
          [key]: next,
        };
      } catch (e) {
        this.showMessage('Failed to update saved state');
      }
    },
    async saveSubscription(subscriptionId) {
      const form = this.editForms[subscriptionId];
      if (!form) return;

      if (!form.enabled) {
        await this.deleteSubscription(subscriptionId);
        return;
      }

      if (!form.marketplace_id) {
        this.showMessage('Please select marketplace.');
        return;
      }
      try {
        const payload = {
          id: Number(subscriptionId),
          marketplace_id: Number(form.marketplace_id),
        };
        if (form.country_id !== '' && form.country_id !== null && form.country_id !== undefined) {
          payload.country_id = Number(form.country_id);
        }
        const res = await MatchmakingService.updateMarketplaceProjectSubscription(payload);
        this.ensureApiOk(res?.data);
        this.showMessage('Subscription updated');
        await this.fetchSubscriptions();
        this.contentsBySubscriptionId = {};
        this.contentsVisibleId = null;
      } catch (e) {
        this.showMessage(e?.message || 'Failed to update subscription');
      }
    },
    async deleteSubscription(subscriptionId) {
      try {
        const res = await MatchmakingService.deleteMarketplaceProjectSubscription(subscriptionId);
        this.ensureApiOk(res?.data);
        this.showMessage('Subscription deleted');
        await this.fetchSubscriptions();
        const key = String(subscriptionId);
        if (this.contentsBySubscriptionId[key]) {
          const next = { ...this.contentsBySubscriptionId };
          delete next[key];
          this.contentsBySubscriptionId = next;
        }
        if (this.contentsVisibleId === subscriptionId) this.contentsVisibleId = null;
        if (this.expandedId === subscriptionId) this.expandedId = null;
      } catch (e) {
        this.showMessage(e?.message || 'Failed to delete subscription');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.subscriptions-page {
  grid-template-columns: 1fr !important;
}

.subscriptions-page .accFeed__content,
.subscriptions-page .matchmaking__content {
  width: 100%;
  max-width: 100%;
}

.subscriptions-page .market-project {
  min-height: 420px;
  padding-bottom: 24px;
}

.subscriptions-page .subscribe {
  background: transparent;
  padding: 0;
  margin: 0;
  border-radius: 0;
}

.subscriptions-page #accordionSubscribes,
.subscriptions-page .subscribe__item,
.subscriptions-page .subscribe__header,
.subscriptions-page .subscribe__body {
  width: 100%;
}

.subscriptions-page .subscribe__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
}

.subscriptions-page .subscribe__header .subscribe__label {
  display: inline-flex;
  align-items: center;
  flex: 1 1 auto;
  min-width: 0;
}

.subscriptions-page .subscribe__body {
  box-sizing: border-box;
  padding: 20px 30px 24px;
}

.subscriptions-page .subscribe__body .subscribe-form-row {
  margin-bottom: 14px;
}

.offers-status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.subscribe-form-row {
  margin-bottom: 12px;
}

.subscribe-form-row label {
  display: block;
  margin-bottom: 6px;
}

.subscribe__body.show {
  display: block;
}

.subscribe__buttons .btn-action {
  width: auto;
  min-width: 0;
  display: inline-flex;
}

.subscription-contents {
  margin-top: 12px;
}

.subscription-contents__list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.subscription-contents__item {
  margin-bottom: 6px;
}

.subscription-contents__item:last-child {
  margin-bottom: 0;
}

.subscription-contents__cards .market-project__title {
  font-size: 20px;
  font-weight: 600;
  line-height: 26px;
  margin: 0 0 10px 0;
  border-bottom: none !important;
  color: #1d5c99;
}

.subscription-contents__cards .card {
  border-radius: 12px !important;
  margin-bottom: 10px;
}

.subscription-contents__cards .card:last-child {
  margin-bottom: 0;
}

.subscription-contents__cards .btn-accordion {
  border-radius: 12px;
}

.subscription-contents__cards .market-project__actions {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.subscription-contents__cards .market-project__buttons {
  margin-top: auto;
  justify-content: flex-start;
}

.subscription-contents__cards .market-project__info,
.subscription-contents__cards .status-multi {
  text-align: left;
  align-self: flex-start;
}
</style>
